import checkForAuthenticatedBotToken from './check-for-authenticated-bot-token';

function getBotAuthMiddleware(app, authenticatedBotHeaders) {
  return (_, { headers }) => {
    const botToken = checkForAuthenticatedBotToken(app, authenticatedBotHeaders);
    if (!botToken) return { headers };

    return {
      headers: {
        ...headers,
        authorization: `Bearer ${botToken}`
      }
    };
  };
}
export default getBotAuthMiddleware;
